export const actions = {
  set_state: 'sub_account/set_state',
  get_subaccount: 'sub_account/get_subaccount',
  create_subaccount: 'sub_account/create_subaccount',
  access_subaccount: 'sub_account/access_subaccount',
  update_subaccount: 'sub_account/update_subaccount',
  delete_subaccount: 'sub_account/delete_subaccount'
}
